type Input = {
  value: string
  key: string
}

type Output =
  | {
      success: true
    }
  | {
      success: false
      error: string
    }

export const trySaveToLocalStorage = ({ value, key }: Input): Output => {
  try {
    localStorage.setItem(key, value)
    return { success: true }
  } catch (error) {
    console.error('Error storing item in localStorage', error, value, key)
    return { success: false, error: (error as Error).message }
  }
}
